import { useContext } from "react";
import { RenderContext } from "../contexts";

export function useRender() {
  const renderer = useContext(RenderContext);
  if (!renderer) {
    throw new Error("useRender must be used within a RenderContext");
  }
  return renderer;
}
